import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { CheckboxWrap, CheckboxItemWrap, CheckboxBg, CheckboxBody } from './checkbox.style';


//codepen link - https://codepen.io/webopixel/pen/zomRoX

export const Checkbox = forwardRef(({ id, labelText, ...rest }, ref) => {
    return (
        <CheckboxWrap>
            <CheckboxItemWrap>
                <input
                    type="checkbox"
                    id={id}
                    name={id}
                    ref={ref}
                    {...rest}
                />
                {/* <CheckboxBg/>
                <CheckboxBody>
                    
                </CheckboxBody> */}
                <label htmlFor={id}>{labelText}</label>{" "}
            </CheckboxItemWrap>
        </CheckboxWrap>
    )
})
